var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"footer"},[_vm._t("default")],2),_c('div',{staticClass:"placeholder",style:({ height: _vm.height })})])}
var staticRenderFns = []

export { render, staticRenderFns }